var _a;
export var ShrinkageSubcategory = {
    SickAbsence: 'sick_absence',
    ShortTermLeave: 'short_term_leave',
    LongTermLeave: 'long_term_leave',
    MaternityParental: 'maternity_parental',
    LeaveWithoutPay: 'leave_without_pay',
    Custom: 'custom',
};
export var SHRINKAGE_SUBCATEGORY_TYPES = Object.values(ShrinkageSubcategory);
export var SHRINKAGE_SUBCATEGORY_TRANS_KEYS = (_a = {},
    _a[ShrinkageSubcategory.SickAbsence] = 'shrinkage.subcategories.sick_absence',
    _a[ShrinkageSubcategory.ShortTermLeave] = 'shrinkage.subcategories.short_term_leave',
    _a[ShrinkageSubcategory.LongTermLeave] = 'shrinkage.subcategories.long_term_leave',
    _a[ShrinkageSubcategory.MaternityParental] = 'shrinkage.subcategories.maternity_parental',
    _a[ShrinkageSubcategory.LeaveWithoutPay] = 'shrinkage.subcategories.leave_without_pay',
    _a[ShrinkageSubcategory.Custom] = 'shrinkage.subcategories.custom',
    _a);
